export default [

    {
        ques:"What are the benefits of getting ECG?",
        ans:"An ECG test helps screen and diagnose a variety of cardiac problems. It’s the most common way to check if your heart is healthy or monitor existing heart diseases.<br/> If you are experiencing symptoms related to heart problems, have a heart disease in your family or have a lifestyle that negatively impacts your health, you might benefit from an ECG scan or long term monitoring."
    },
    {
        ques:"What happens during an ECG test?",
        ans:"Twelve small sticky patches called electrodes are put on your arms, legs and chest. These are connected by wires to an ECG machine which picks up the electrical signals that make your heart beat. This electrical activity is recorded and printed onto paper."
    },
    {
        ques:"What can an ECG show?",
        ans:"An ECG can help detect problems with your heart rate or heart rhythm. It can help doctors tell if you’re having a heart attack or if you’ve had a heart attack in the past.An ECG is usually one of the first heart tests you will have. It does have some limitations, so often you will have one or more other tests too. An abnormal ECG reading doesn’t always mean there is something wrong with your heart."
    }

]